import { Route } from '@angular/router'

export const TempRoutes: Route[] = [
    {
        path: 'demo/video-player',
        loadComponent: () =>
            import('./demo-video-player/demo-video-player.component').then(
                (c) => c.DemoVideoPlayerComponent,
            ),
        data: { pageTitle: 'Video Player Demo' },
    },
]
